const normalizeHost = (value: string): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return null;

  try {
    return new URL(trimmed.includes('://') ? trimmed : `https://${trimmed}`).hostname.toLowerCase();
  } catch {
    return null;
  }
};

const parseHostList = (value: string | undefined): Set<string> => {
  if (!value) return new Set();

  return new Set(
    value
      .split(',')
      .map(normalizeHost)
      .filter((host): host is string => Boolean(host))
  );
};

const hostFromUrl = (value: string | undefined): string | null => {
  if (!value) return null;

  try {
    return new URL(value).hostname.toLowerCase();
  } catch {
    return null;
  }
};

export const getBloominTrustedChallengeHosts = (): Set<string> => {
  const hosts = parseHostList(import.meta.env.VITE_BLOOMIN_3DS_CHALLENGE_URL_HOSTS);
  const apiEndpointHost = hostFromUrl(import.meta.env.VITE_API_ENDPOINT);

  if (apiEndpointHost) {
    hosts.add(apiEndpointHost);
  }

  return hosts;
};

export const isTrustedBloominChallengeUrl = (url: URL): boolean => {
  if (url.protocol !== 'https:') {
    return false;
  }

  return getBloominTrustedChallengeHosts().has(url.hostname.toLowerCase());
};

/**
 * Bloomin 3DS challenge URL 신뢰 검증 실패 sentinel (SP2-2b Minor 시정).
 *
 * challenge URL parse 실패 / 신뢰 불가 host 를 식별하는 전용 에러 타입.
 * 문자열(localized 메시지) 동등 비교 대신 `instanceof` 로 식별해, labels 가
 * 부모 재렌더로 새 참조가 돼도 untrustedChallenge ↔ generic 오분류를 차단한다.
 *
 * `message` 는 throw 시점에 주입된 localized 문구를 그대로 보존한다.
 */
export class UntrustedChallengeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UntrustedChallengeError';
  }
}
